var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldCheckSolid = function SvgShieldCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.498 2.438a.75.75 0 0 0-.994 0 11.25 11.25 0 0 1-7.969 2.813.75.75 0 0 0-.754.537 12.75 12.75 0 0 0 9.032 15.938.75.75 0 0 0 .376 0A12.75 12.75 0 0 0 21.22 5.788a.75.75 0 0 0-.753-.537 11.25 11.25 0 0 1-7.97-2.813ZM15.53 9.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06L11 12.94l3.47-3.47a.75.75 0 0 1 1.06 0Z",
    fill: "currentColor"
  })));
};
export default SvgShieldCheckSolid;